<!-- <textarea rows="10" cols="50"  (change)="onJsonChange($event)" [(ngModel)]="jsonData" >
    {{jsonData | json}} 
</textarea>   -->
<!-- [(ngModel)]="jsonData| json"  -->

<div class='textarea' contenteditable style="overflow-y:auto;max-height: 65vh;" (blur)="onJsonChange($event)" > <!--(input)="onJsonChange($event)"  -->
    <pre><p>{{jsonData | json}} </p></pre>
    <!-- <button  type="submit" >save changes</button> -->
</div>